// Reconciliation: the routes and the sidebar rows of `wealth.ops.reconciliation` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.reconciliation',
    routes: [
        {
            frontend: 'ops',
            path: 'reconciliation',
            lazy: () => import('@/pages/ops/reconciliation/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'reconciliation',
            label: 'Reconciliation',
            href: '/ops/reconciliation',
            icon: 'Scale',
            group: 'processing',
            order: 210,
        },
    ],
});
